import { useCallback, useState } from "react";
import { OrderingForSaleProps } from "../components/main/detailsOrder.props";
import { CreateParameters } from "../interfaces/tinkoff/createParameters";
import { TinkoffService } from "../services/tinkoff.service";
import { ConfigServer } from "../configs/config.server";
import _ from "lodash";
import { useCreateOrdering } from "./useCreateOrdering";
import { CustomerPaymentState } from "../types/types";
import Router from "next/router";

export const usePayTinkoff = (props: OrderingForSaleProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const config = ConfigServer(props.hostName);
  const createOrdering = useCreateOrdering(props, config);
  
  const payTinkoff = useCallback(async (model: CustomerPaymentState, accountPaymentForTinkoff: string) => {
    setIsLoading(true);

    try {
      const orderingForSale = { ...props.orderingForSale };

      if (orderingForSale.orderingId) {
        const createParameters: CreateParameters = {
          isTest: false,
          accountPayment: accountPaymentForTinkoff,
          webSitesName: config.WebSitesName,
          orderingId: orderingForSale.orderingId,
        };

        const resultRequest = await TinkoffService.create(createParameters, config.ServiceInternetAcquiring.Create);

        if (!resultRequest.isError) {
          Router.push(resultRequest.url);
          return;
        }
      }

      if (orderingForSale?.customer) {
        orderingForSale.customer.email = model.email;
        orderingForSale.customer.firstName = model.firstName;
        orderingForSale.customer.lastName = model.lastName;

        const phoneDigits = model.phone.replace(/\D/g, '');
        orderingForSale.customer.phone = parseInt(phoneDigits, 10);
      }

      const newOrderingId = await createOrdering(model);
      if (newOrderingId) {
        orderingForSale.orderingId = newOrderingId;
      }

      const createParameters: CreateParameters = {
        isTest: false,
        accountPayment: accountPaymentForTinkoff!,
        webSitesName: config.WebSitesName,
        orderingId: newOrderingId!,
      };

      const resultRequest = await TinkoffService.create(createParameters, config.ServiceInternetAcquiring.Create);

      if (!resultRequest.isError) {
        Router.push(resultRequest.url);
        return;
      }
    } catch (error) {
      console.log('Pay Tinkoff error:', error);
    } finally {
      setIsLoading(false);
    }
  }, [props, config, createOrdering]);

  return { payTinkoff, isLoading };
};